import { gql } from 'graphql-tag';

import { PriceInfoFragment } from '.';

export const SkuInfoFragment = gql`
  ${PriceInfoFragment}
  fragment SkuInfo on SKUType {
    description
    marketedTime
    name
    shortName
    skuID
    price {
      ...PriceInfo
    }
  }
`;
